module.exports = __webpack_public_path__ + "static/media/r187.37d9a71b.jpg";